import { render } from "./self-reg.vue?vue&type=template&id=7fc56e75&ts=true"
import script from "./self-reg.vue?vue&type=script&lang=ts"
export * from "./self-reg.vue?vue&type=script&lang=ts"

import "./self-reg.vue?vue&type=style&index=0&id=7fc56e75&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__